/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable react/prop-types */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import { Trans } from 'react-i18next';
import { useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircleCheck } from '@fortawesome/free-solid-svg-icons';
import ReactCountryFlag from 'react-country-flag';
import Searchbar from '../../../Components/Searchbar/Searchbar';
import Dropdown from '../../../Components/Dropdown/Dropdown';

const gP = (key) => `page-external-authorization.bank-auth-step${key}`;

const gT = (t, key) => t(`page-external-authorization.bank-auth-step${key}`);

const shouldUnescape = true;
const tOptions = Object.freeze({
  returnObjects: true,
  joinArrays: '',
});

export default function BankAuthStep({
  completed,
  banks,
  countries,
  selectedCountry,
  onCountryClick,
  selectBank,
  error,
  errorText,
  t,
}) {
  const [searchQuery, setSearchQuery] = useState('');
  const [countryDropdownOpen, setCountryDropdownOpen] = useState(false);

  const popularBanks = ['Handelsbanken', 'Nordea', 'SEB', 'Svea', 'Swedbank'];

  const filteredBanks = searchQuery
    ? banks.filter((bank) => {
        return bank.name?.toLowerCase().includes(searchQuery?.toLowerCase());
      })
    : banks;

  const calculateBankRank = (bankName) =>
    bankName.includes('Card')
      ? -1
      : popularBanks.some((popularBank) => {
          return bankName.includes(popularBank);
        })
      ? 1
      : 0;

  // Sort by popular banks.
  const sortedBanks = filteredBanks.sort((a, b) => {
    return calculateBankRank(b.name) - calculateBankRank(a.name);
  });

  return (
    <div className="auth-step">
      {completed ? (
        <div className="auth-step-completed-content">
          <FontAwesomeIcon
            className="auth-complete-icon"
            icon={faCircleCheck}
          />
          <p className="auth-complete-header">
            {gT(t, '.auth-complete-header')}
          </p>
        </div>
      ) : (
        <>
          <p className="auth-step-header">
            <Trans
              t={t}
              i18nKey={gP('.auth-step-header')}
              {...{ shouldUnescape, tOptions }}
            />
          </p>
          <p className="auth-step-description">
            <Trans
              t={t}
              i18nKey={gP('.auth-step-description')}
              {...{ shouldUnescape, tOptions }}
            />
          </p>
          {error && (
            <div className="auth-step-error">
              <p>{errorText ?? gT(t, '.error.connect-bank')}</p>
            </div>
          )}
          <div className="bank-nav">
            <Searchbar
              placeholder={gT(t, '.searchbar-placeholder')}
              onChange={(e) => setSearchQuery(e.target.value)}
            />
            <Dropdown
              open={countryDropdownOpen}
              title={selectedCountry.name}
              componentIcon={
                <ReactCountryFlag countryCode={selectedCountry.code} svg />
              }
              onClick={() => setCountryDropdownOpen(!countryDropdownOpen)}
              onClickOutside={() => setCountryDropdownOpen(false)}
              right
            >
              {countries.map((country) => (
                <Dropdown.Item
                  key={country.code}
                  content={
                    <div className="country-item">
                      <ReactCountryFlag countryCode={country.code} svg />
                      <p>{country.name}</p>
                    </div>
                  }
                  onClick={() => {
                    setCountryDropdownOpen(false);
                    onCountryClick(country);
                  }}
                />
              ))}
            </Dropdown>
          </div>
          <div className="bank-grid">
            {sortedBanks.map((data) => (
              <div
                className="bank-button"
                onClick={() => selectBank(data)}
                role="button"
                tabIndex="0"
                key={`${data.name} ${data.country} ${data.bic}`}
              >
                <div className="button-content-container">
                  <p>{data.name}</p>
                  <img className="bank-image" src={data.logo} alt="Bank logo" />
                </div>
              </div>
            ))}
          </div>
        </>
      )}
    </div>
  );
}
